// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1Csm3","actionsCol":"EnrolledClinics_actionsCol__1yo6t"};